import type { App } from "vue";
import { createApp } from "vue";
import DOMUtils from "@utils/dom.utils";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";
import PdfViewerContainer from "./components/PdfViewerContainer.vue";
import { PDF_VIEWER_OPEN_KEY, useDefaultPdfViewerOpen } from "./composables/use-pdf-viewer-open.ts";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let containerComponent: any = null;
// Guard: AppInstanceUtils.installCommonPlugin re-installs all plugins (including this one)
// on the sub-app. We must not re-enter container creation during that process.
let isInitializing = false;

const getPdfViewerContainer = () => {
  if (containerComponent || isInitializing) return containerComponent;
  isInitializing = true;

  const el = DOMUtils.createDivInBody({ class: "pdf-viewer-container" });
  const app = createApp(PdfViewerContainer);
  AppInstanceUtils.installCommonPlugin(app);
  containerComponent = app.mount(el);
  DOMUtils.replaceComponentWrapperWithComponentElement(containerComponent);

  isInitializing = false;
  return containerComponent;
};

const PdfViewerPlugin = {
  install(app: App) {
    getPdfViewerContainer();
    // Provide the default (view-only) open fn at app level so any MediaComponent
    // can open the PDF viewer without needing a parent to handle @open-pdf-overlay.
    // AuthoringCoPilotKnowledgeBase overrides this via provide() with capture context.
    app.provide(PDF_VIEWER_OPEN_KEY, useDefaultPdfViewerOpen());
  },
};

export default PdfViewerPlugin;
